module.exports = __webpack_public_path__ + "96a54b628407c8a2d05a79fa2125581f.png";